import type { Validate } from 'react-hook-form';

export function combineValidators<TFieldValue = string>(
  ...validators: Validate<TFieldValue>[]
): Validate<TFieldValue> {
  return function combinedValidator(value: TFieldValue) {
    for (const validator of validators) {
      const result = validator(value);

      if (result === false || typeof result === 'string') {
        return result;
      }
    }

    return undefined;
  };
}
